module.exports = __webpack_public_path__ + "img/icon_dream.bd22a9d7.png";